import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Label } from 'core/components/label';
import ValueField from 'core/components/value-field';
import { currencyFormatter, laymanDateTimeFormatter } from 'core/helpers/formatters';
import equalsIcon from 'core/assets/svg/equals.svg';
import timesIcon from 'core/assets/svg/times.svg';

import useStyles from '../policy-sidebar.styles';

const Row = ({ classes, label, value, emphasizeValue }) => (
  <div className={classes.mutualRow}>
    <Label type="infoLabel" className={classes.mutualRowLabel}>
      {label}
    </Label>
    <Label
      type="infoValue"
      className={classNames(classes.mutualRowValue, { [classes.mutualRowValueEmphasis]: emphasizeValue })}
    >
      {value}
    </Label>
  </div>
);

Row.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  emphasizeValue: PropTypes.bool
};

Row.defaultProps = {
  emphasizeValue: false
};

const MutualSegmentContent = ({ segment, isDraft, createdByUsername, createdDateTime, changePremiumFormatter }) => {
  const classes = useStyles({ isDraft });

  return (
    <>
      <Row classes={classes} label="Policy Premium" value={currencyFormatter(segment.premium)} emphasizeValue />
      {isDraft && (
        <>
          <Row classes={classes} label="Created by" value={createdByUsername} />
          <Row
            classes={classes}
            label="Created"
            value={createdDateTime ? laymanDateTimeFormatter(createdDateTime) : null}
          />
        </>
      )}
      <hr className={classes.mutualDivider} />
      <ValueField
        className={classNames(classes.valueFieldInline, classes.valueFieldContent)}
        label="Daily Rate"
        value={currencyFormatter(segment.dailyRate)}
      />
      <img src={timesIcon} alt="Times" className={classes.timesIcon} />
      <ValueField
        className={classNames(classes.valueFieldInline, classes.valueFieldContent)}
        label="Days"
        value={segment.segmentDays}
      />
      <img src={equalsIcon} alt="Equals" className={classes.equalsIcon} />
      <ValueField
        className={classNames(classes.valueFieldInline, classes.valueFieldContent)}
        label="Change Premium"
        formatter={changePremiumFormatter}
        value={currencyFormatter(segment.segmentPremium)}
      />
    </>
  );
};

MutualSegmentContent.propTypes = {
  segment: PropTypes.object.isRequired,
  isDraft: PropTypes.bool,
  createdByUsername: PropTypes.string,
  createdDateTime: PropTypes.string,
  changePremiumFormatter: PropTypes.func
};

MutualSegmentContent.defaultProps = {
  isDraft: false,
  createdByUsername: null,
  createdDateTime: null,
  changePremiumFormatter: null
};

export default MutualSegmentContent;
